import React, { Component } from 'react';
import { format } from "date-fns";
import { Big3Common, bootstrap } from '../../js/IncludeManager'
import { Alert } from "../../js/ComponentManager";
import { Big3DatePicker } from "../../js/ComponentManager";

/* 개발담당:이재호
 * 화면기능:결제내역
 * 세부설명:
*/

export class PaymentList extends Component {
    static displayName = PaymentList.name;

    constructor(props) {
        super(props);

        let fromDate = format(Big3Common.Util.DateAdd(new Date(), -3), "yyyy-MM-dd");
        let toDate = format(Big3Common.Util.DateAdd(new Date(), 1), "yyyy-MM-dd");

        this.state = {
            Refund_Yn: "N",
            Bill_Yn: "N",
            Amount: "",
            Clod_Point: "",
            Card_Info: "",
            Card_Reg: "",
            Depo_Idx: "OT",
            PaymentList: [],
            Content: "",
            Title: "",
            FromDate: fromDate,
            ToDate: toDate,
        };

        this.handleCalendarChange = this.handleCalendarChange.bind(this);
        /*this.handleTab_Click = this.handleTab_Click.bind(this);*/
    }
    //초기화
    componentDidMount() {
        /*this.GetRefund();*/
        this.GetbillingKey();
        /*this.GetPoint();*/
        this.GetCardInfo();
        this.GetPaymentList();
    }
/*    //환불요청 확인
    async GetRefund() {
        try {
            let Data = await Big3Common.Post("api/Common/Common/GetRefund", {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.dataTable);
                const Refund_Yn = DataList[0]["refund_yn"]
                this.setState({
                    Refund_Yn: Refund_Yn
                })
            }
            else {
                alert(Data.message);
            }
        }
        catch (e) {
            console.log("GetRefundCount: ", e)
        }
        return false;
    }
    //포인트 조회
    async GetPoint() {
        try {
            let Data = await Big3Common.Post("api/Common/Common/GetPoint", {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.dataTable);
                const Clod_Point = DataList[0]["total_point"]
                this.setState({
                    Clod_Point: Clod_Point
                })
            }
            else {
                alert(Data.message);
            }
        }
        catch (e) {
            console.log("GetPoint: ", e)
        }
        return false;
    }*/
    //카드등록확인
    async GetbillingKey() {
        try {
            //주문유형 
            let Data = await Big3Common.Post('api/Common/Common/GetbillingKey', {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let Bill_Yn = "Y"
                this.setState({ Bill_Yn: Bill_Yn });

            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetbillingKey", e);
        }
        return false;
    }
    //카드정보 조회
    async GetCardInfo() {
        try {
            let Data = await Big3Common.Post("api/Common/Common/GetCardInfo", {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let card_info = JSON.parse(Data.multiDataTable);
                this.setState({
                    Card_Info: card_info.card,
                    Card_Reg: card_info.reg_date
                })
            }
            else {
                alert(Data.message);
            }
        }
        catch (e) {
            console.log("GetCardInfo: ", e)
        }
        return false;
    }
    async GetPaymentList(Depo_Idx = "") {
        try {

            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/Common/Common/GetPaymentList',
                {
                    FromDate: this.state.FromDate,
                    ToDate: this.state.ToDate,
                    Depo_Idx: Depo_Idx === "" ? this.state.Depo_Idx : Depo_Idx
                }, true);

            if (Data.codeName === Big3Common.ResultCode.Success) {
                let PaymentList = JSON.parse(Data.dataTable);
                this.setState({
                    PaymentList: PaymentList
                });

            }
            else if (Data.codeName === Big3Common.ResultCode.Warning) {
                this.setState({ Title: Data.message });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetPaymentList", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
/*    //링크
    async handle_RenderComponent(event, ComponentName) {
        if (ComponentName === 'ChargePoint') {
            if (this.state.Bill_Yn === "N") {
                this.setState({ Title: "카드 등록 후 충전이 가능합니다." });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                return false;
            }
            else {
                this.props.RenderComponent(ComponentName);
            }
        }
        else {
            this.props.RenderComponent(ComponentName);
        }
        event.preventDefault();
    }*/
/*    handle_CancleRefund = async (event) => {
        try {
            let Data = await Big3Common.Post('api/Common/Common/CancleRefund', {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ Title: "환불취소안내", Content: Data.message });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
                this.GetRefund();
            }
            else if (Data.codeName === Big3Common.ResultCode.Warning) {
                this.setState({ Title: "환불취소안내", Content: Data.message });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            }
        }
        catch (e) {
            console.log("handle_CancleRefund", e);
        }
        return false;
    }*/
    //달력일자 선택
    handleCalendarChange(retunData) {
        this.setState({ [retunData.returnId]: retunData.SelectDate });
    }
/*    handleTab_Click(event, Depo_Idx) {
        this.setState({ Depo_Idx: Depo_Idx });
        this.GetPaymentList(Depo_Idx);
        event.preventDefault();
    }*/

    PaymentListrender() {
        const PaymentList = this.state.PaymentList;
        return (
            <div className="payment_list_box">
                {PaymentList.map(list =>
                    <div className="payment_list" key={list.seqno}>
                        <div className="date">{list.depo_dt}</div>
                        <div className="payment_info flex_sb">
                            <div className="payment_detail flex_fs">
                                <div className={list.depo_idx === "OT" ? "payment_item withdrawal" :"payment_item deposit"}>{list.depo_idx_nm}</div>
                                <div className="detail">{list.depo_nm}</div>
                            </div>
                            {
                                list.depo_idx === "OT" ?
                                    <div className="amount m_minus">{Big3Common.Util.Money(list.price2)}원</div>
                                    :
                                    <div className="amount m_plus">+{Big3Common.Util.Money(list.price2)}원</div>
                            }
                        </div>
                        {/*<div className="balance">잔액 {Big3Common.Util.Money(list.sum_price)}P</div>*/}
                    </div>
                )}
            </div>
        )
    }
    render() {
        const PaymentListrender = this.PaymentListrender()
        return (
            <div className="container_box2 p_b_margin c_padding">

                <div className="my_point_box">
                    {/*<div className="point_box flex_sb">
                        <div>
                            <div className="point_tit">클로디 포인트</div>
                            <div className="my_point">{Big3Common.Util.Money(this.state.Clod_Point)}P</div>
                        </div>
                        <div className="button_box flex_fe">
                            {
                                this.state.Refund_Yn === 'N' ?
                                    <>
                                        */}{/*<button className="point_c" onClick={(e) => { this.handle_RenderComponent(e, 'ChargePoint') }}>포인트충전</button>*/}{/*
                                        <button className="point_c" onClick={(e) => { this.handle_RenderComponent(e, 'RefundPolicy') }}>카드등록</button>
                                    </>
                                    :
                                    <>
                                        */}{/*<button className="point_w" onClick={(e) => { this.handle_CancleRefund(e); }}>환불취소</button>*/}{/*
                                        <button className="point_d">카드등록</button>
                                    </>
                            }
                        </div>
                    </div>*/}
                    <div>
                        <div className="tit">결제수단 : {this.state.Card_Info}</div>
                        {/*<div className="my_point"></div>*/}
                    </div>
                    <div className="tit">등록일 : {this.state.Card_Reg}</div>
                </div>

                {/*<div className="title_box"><div className="title">포인트 충전</div></div>*/}

                <div className="search_box_v2 n_margin">
                    <div className="select_date_box n_margin">
                        <div className="select_date_box_input">
                            <Big3DatePicker
                                className="form-control"
                                setDate={new Date(this.state.FromDate)}
                                DateChange={this.handleCalendarChange}
                                id="FromDate"
                            />
                            <div className="calendar_btn"></div>
                        </div>
                        <div className="select_date_box_input">
                            <Big3DatePicker
                                className="form-control"
                                setDate={new Date(this.state.ToDate)}
                                DateChange={this.handleCalendarChange}
                                id="ToDate"
                            />
                            <div className="calendar_btn"></div>
                        </div>
                        <button type="button" className="date_s_btn" onClick={() => { this.GetPaymentList(); }}>조회</button>
                    </div>
                </div>

                <div className="list_tab_box flex_fs">
                    <div className={this.state.Depo_Idx === "OT" ? "tab select" : "tab"}>전체</div>
                    {/*<div className={this.state.Depo_Idx === "IN" ? "tab select" : "tab"} onClick={(e) => { this.handleTab_Click(e, 'IN') }}>입금</div>
                    <div className={this.state.Depo_Idx === "OT" ? "tab select" : "tab"} onClick={(e) => { this.handleTab_Click(e, 'OT') }}>출금</div>*/}
                </div>
                {PaymentListrender}
                <Alert
                    id="MessageAlert"
                    content={this.state.Content}
                    title={this.state.Title}
                />
            </div>
        );
    }
}
